import React from "react";
import { Umbrella2 } from "../../icons/Umbrella2";
import "./style.css";

export const UmbrellaWrapper = () => {
  return <Umbrella2 className="umbrella-2" />;
};
